import { MEETING } from '..'

const initialMeetingInfo = {
  bookingDetail: {},
  rawBookingDetail: {},
  cateringList: [],
  equipmentList: [],
  issueReport: {},
}

export default function meetingReducer (state = initialMeetingInfo, action) {
  switch (action.type) {
    case MEETING.actionType.SET_ALL_BOOKING_DETAIL:
      return {
        ...state,
        bookingDetail: action.data.bookingDetail,
        cateringList: action.data.cateringList,
        equipmentList: action.data.equipmentList,
        rawBookingDetail: action.data.rawBookingDetail,
      }
      
    case MEETING.actionType.SET_BOOKING_DETAIL:
      return {
        ...state,
        bookingDetail: action.data,
      }

    case MEETING.actionType.RESET_ALL_MEETING_INFO:
      return {
        ...state,
        ...initialMeetingInfo,
      }

    default:
      return state
  }
}
